// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dCoordinates from "../Data.Coordinates/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
const coordinatesIsSymbol = {reflectSymbol: () => "coordinates"};
const restaurantIdIsSymbol = {reflectSymbol: () => "restaurantId"};
const ReverseGeocodeRequestIsSymbol = {reflectSymbol: () => "ReverseGeocodeRequest"};
const ReverseGeocodeRequest = x => x;
const rPCSitesReverseGeocodeReq = {};
const rPCMethodNameReverseGeoco = {rpcMethodName: v => "ReverseGeocodeRequest"};
const newtypeReverseGeocodeRequ = {Coercible0: () => {}};
const hasFieldReverseGeocodeReq = dictHasField => dictHasField;
const eqReverseGeocodeRequest = {
  eq: x => y => x.coordinates.lat === y.coordinates.lat && x.coordinates.lon === y.coordinates.lon && (() => {
    if (x.restaurantId.tag === "Nothing") { return y.restaurantId.tag === "Nothing"; }
    if (x.restaurantId.tag === "Just") {
      if (y.restaurantId.tag === "Just") { return x.restaurantId._1 === y.restaurantId._1; }
      return false;
    }
    return false;
  })()
};
const genericReverseGeocodeRequest = {to: x => x, from: x => x};
const showReverseGeocodeRequest = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ coordinates: " + Data$dCoordinates.showCoordinates.show(v.coordinates) + (() => {
          if (v.restaurantId.tag === "Just") { return ", restaurantId: (Just " + Data$dShow.showIntImpl(v.restaurantId._1) + ") "; }
          if (v.restaurantId.tag === "Nothing") { return ", restaurantId: Nothing "; }
          $runtime.fail();
        })() + "}"
      ]
    })(ReverseGeocodeRequestIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeReverseGeocodeRequest = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(coordinatesIsSymbol)(Data$dCoordinates.unscrambleDecodeCoordinates)(Unscramble.decodeRecordCons(restaurantIdIsSymbol)(Unscramble.decodeMaybe(Unscramble.decodeInt1))(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeReverseGeocodeRequest = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericReverseGeocodeRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(ReverseGeocodeRequestIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(restaurantIdIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))(coordinatesIsSymbol)({encodeWithOptions: v => Data$dCoordinates.encodeCoordinates.encode});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeReverseGeocodeRequest = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericReverseGeocodeRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ReverseGeocodeRequestIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(restaurantIdIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.intDecode.decode)
  })())(coordinatesIsSymbol)({decodeWithOptions: v => Data$dCoordinates.decodeCoordinates.decode})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  ReverseGeocodeRequest,
  ReverseGeocodeRequestIsSymbol,
  coordinatesIsSymbol,
  decodeReverseGeocodeRequest,
  encodeReverseGeocodeRequest,
  eqReverseGeocodeRequest,
  genericReverseGeocodeRequest,
  hasFieldReverseGeocodeReq,
  newtypeReverseGeocodeRequ,
  rPCMethodNameReverseGeoco,
  rPCSitesReverseGeocodeReq,
  restaurantIdIsSymbol,
  showReverseGeocodeRequest,
  unscrambleDecodeReverseGeocodeRequest
};
